<template>
  <portal to="layout">
    <ModalDialog
      id="actionPendingModal"
      action-alignment="center"
      overlay="dark"
      size="small"
      :overlay-close="false"
      :escape-button="false"
    >
      <template v-if="!!$slots.header || !!header" #header>
        <slot name="header">
          {{ header }}
        </slot>
      </template>

      <AnnularThrobber class="mx-auto mb-4" />

      <TypeBody
        tag="div"
        variant="text-x-small-tight"
        class="text-base-700"
        weight="regular"
      >
        <slot>{{ message }}</slot>
      </TypeBody>
    </ModalDialog>
  </portal>
</template>

<script>
import { AnnularThrobber, ModalDialog, TypeBody } from '@bambeehr/pollen';

export default {
  components: {
    AnnularThrobber,
    ModalDialog,
    TypeBody,
  },
  props: {
    header: {
      type: String,
      required: false,
      default: '',
    },
    message: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
